module.exports = __webpack_public_path__ + "static/img/question_banner.42268edf.png";